module.exports = __webpack_public_path__ + "static/assets/98d9385cd2b050202163a26543683459.svg";